$(document).ready(function () {
  $(".scroll-btn").click(function () {
    var header = $("#shopify-section-header").height() + 20;
    $("html, body").animate(
      {
        scrollTop: $("#form-wrapper").offset().top - header,
      },
      500
    );
  });
});

jQuery(".play-video").each(function (index) {
  jQuery(this).click(function (event) {
    event.preventDefault();
    var video_url = jQuery(this).data("video");
    if (video_url) {
      if (jQuery(this).hasClass("play-video-open")) {
        var video = jQuery(this).find(".video-ajax video").get(0);
        if (video.paused === false) {
          video.pause();
        } else {
          video.play();
        }
      } else {
        jQuery(".video-ajax").html("");
        jQuery(".play-video-popup").removeClass("play-video-open");
        jQuery(this)
          .find(".video-ajax")
          .prepend(
            '<video controls controlsList="nodownload" autoplay><source src="' +
              video_url +
              '" type="video/mp4"></video>'
          );
        jQuery(this).addClass("play-video-open");
      }

      jQuery(this)
        .find("video")
        .on("ended", function () {
          jQuery(".video-loader, .video-ajax").html("");
          jQuery(".play-video").removeClass("play-video-open");
        });
    }
  });
});

jQuery(".video-close").on("click", function (e) {
  e.stopPropagation();
  jQuery(".video-loader, .video-ajax").html("");
  jQuery(".play-video").removeClass("play-video-open");
});

$(document).ready(function () {
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return typeof sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };
  var grantposted = getUrlParameter("contact_posted");
  if (grantposted) {
    var img_src = $(".img-class").data("img");
    $(".img-class").attr("src", img_src);
    $(".img-class").addClass("lazyload");
  } else {
    $(".img-class").addClass("lazyload");
  }
  setTimeout(function () {
    if (grantposted) {
      var headerHeight = jQuery("#shopify-section-header").innerHeight() + 20;
      console.log(headerHeight);
      jQuery("html, body").animate(
        {
          scrollTop: jQuery("#form-wrapper").offset().top - headerHeight,
        },
        "slow"
      );
    }
  }, 2000);
});